import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const Disabled = css`
  box-shadow: none;
  cursor: not-allowed;
  opacity: 0.3;
`;

const Ghost = css`
  background-color: transparent;
  color: ${props => props.theme.carvana.gray.dark};
  border: 1px solid ${props => props.theme.carvana.gray.light};
`;

const baseStyles = css`
  .time-slot {
    background-color: ${props => props.theme.carvana.blue.hover};
    border: 1px solid ${props => props.theme.carvana.blue.hover};
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    display: inline;
    font-size: 12px;
    font-weight: 450;
    height: 48px;
    margin: 8px;
    min-height: 48px;
    max-width: 160px;
    width: 80px;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;

    &:focus {
      outline: none;
      box-shadow: none;
    }

    &:hover {
      background-color: transparent;
      border: 1px solid ${props => props.theme.carvana.gray.dark};
    }

    ${props => props.ghost && Ghost}

    ${props => props.disabled && Disabled}
  }

  .time-slot-selected {
    &:hover {
      background-color: ${props => props.theme.carvana.blue.hover};
      border: 1px solid ${props => props.theme.carvana.blue.hover};
      border-radius: 4px;
      color: white;
    }
  }
`;

const Wrapper = styled.div`
  ${baseStyles}
`;

const TimeButton = styled.button``;

const TimeSlotButton = ({
  children,
  isBusy,
  overrideStyles,
  selected,
  ...rest
}) => {
  let className = 'time-slot';

  className += selected ? ' time-slot-selected' : '';

  return (
    <Wrapper {...rest} css={overrideStyles}>
      <TimeButton className={className} {...rest}>
        {children}
      </TimeButton>
    </Wrapper>
  );
};

TimeSlotButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType])
    .isRequired,
  isBusy: PropTypes.bool,
  overrideStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  selected: PropTypes.bool
};

TimeSlotButton.defaultProps = {
  isBusy: false,
  overrideStyles: null,
  selected: false
};

export default TimeSlotButton;
